export type QuickPick = 'this-month' | 'last-month' | '3-months' | '6-months' | '30-days' | 'all';

export function toISODate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function resolveQuickPick(label: QuickPick): { from: string | null; to: string | null } {
  const today = new Date();
  if (label === 'this-month') {
    return {
      from: toISODate(new Date(today.getFullYear(), today.getMonth(), 1)),
      to: toISODate(today),
    };
  }
  if (label === 'last-month') {
    return {
      from: toISODate(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
      to: toISODate(new Date(today.getFullYear(), today.getMonth(), 0)),
    };
  }
  if (label === '3-months') {
    return {
      from: toISODate(new Date(today.getFullYear(), today.getMonth() - 2, 1)),
      to: toISODate(today),
    };
  }
  if (label === '6-months') {
    return {
      from: toISODate(new Date(today.getFullYear(), today.getMonth() - 5, 1)),
      to: toISODate(today),
    };
  }
  if (label === '30-days') {
    return {
      from: toISODate(new Date(today.getTime() - 30 * 86_400_000)),
      to: toISODate(today),
    };
  }
  return { from: null, to: null };
}

export function detectActiveQuickPick(dateFrom: string, dateTo: string): QuickPick | null {
  const picks: QuickPick[] = ['this-month', 'last-month', '3-months', '6-months', '30-days'];
  for (const p of picks) {
    const { from, to } = resolveQuickPick(p);
    if (from === dateFrom && to === dateTo) return p;
  }
  return null;
}

export const QUICK_PICKS: { label: QuickPick; display: string }[] = [
  { label: 'this-month', display: 'Tháng này' },
  { label: 'last-month', display: 'Tháng trước' },
  { label: '3-months', display: '3 tháng' },
  { label: '6-months', display: '6 tháng' },
  { label: '30-days', display: '30 ngày' },
  { label: 'all', display: 'Tất cả' },
];
